import CompanyInfo from './company-info';

export default CompanyInfo;